(function () {
  "use strict";

  if (window.DivetiaWelcome10Offer) { window.DivetiaWelcome10Offer.init(); return; }

  var ROOT_SELECTOR = "[data-dv-welcome10]";
  var JSON_SELECTOR = "[data-dv-welcome10-json]";
  var FORM_SELECTOR = "form[data-product-id]";
  var subscriptions = {};

  function stringId(value) {
    return value == null ? "" : String(value);
  }

  function allRoots(productId) {
    var selector = productId
      ? ROOT_SELECTOR + '[data-product-id="' + productId + '"]'
      : ROOT_SELECTOR;
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function owningForm(root) {
    return root && root.closest ? root.closest(FORM_SELECTOR) : null;
  }

  function variantMap(root) {
    var node = root && root.querySelector(JSON_SELECTOR);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || "{}") || {};
    } catch (error) {
      return {};
    }
  }

  function currentVariantId(root) {
    var form = owningForm(root);
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? stringId(input.value) : "";
  }

  function renderRoot(root) {
    if (!root) return;

    var variantId = currentVariantId(root);
    var record = variantMap(root)[variantId];
    var amount = root.querySelector("[data-dv-welcome10-amount]");
    var visible = Boolean(
      root.getAttribute("data-enabled") !== "false" &&
      record &&
      record.available &&
      record.formatted &&
      amount
    );

    root.hidden = !visible;
    if (!visible) {
      root.removeAttribute("data-selected-variant-id");
      return;
    }

    // `formatted` is Shopify Liquid's trusted `money` output serialized into
    // this root's JSON. It may intentionally contain presentment markup (for
    // example, a `.money` span) or entities, so preserve that HTML here.
    amount.innerHTML = record.formatted;
    root.setAttribute("data-selected-variant-id", variantId);
  }

  function clearSchedule(root) {
    var timers = root && root.__dvWelcome10Timers;
    if (!timers) return;
    timers.forEach(window.clearTimeout);
    root.__dvWelcome10Timers = null;
  }

  function scheduleRoot(root) {
    clearSchedule(root);
    root.__dvWelcome10Timers = [0, 60, 180].map(function (delay) {
      return window.setTimeout(function () {
        renderRoot(root);
        if (delay === 180) root.__dvWelcome10Timers = null;
      }, delay);
    });
  }

  function scheduleProduct(productId) {
    allRoots(stringId(productId)).forEach(scheduleRoot);
  }

  function bindProduct(productId) {
    productId = stringId(productId);
    if (!productId || subscriptions[productId]) return;

    var bus = window.MinimogEvents || window._ThemeEvent;
    if (bus && typeof bus.subscribe === "function") {
      subscriptions[productId] = true;
      bus.subscribe(productId + "__VARIANT_CHANGE", function () {
        // Product events are shared by product ID and can originate from a
        // main PDP, quick view, sticky instance, or another section. Never
        // broadcast the event variant into every root. Each root instead
        // reads the selected variant from its own enclosing product form.
        scheduleProduct(productId);
      });
    }
  }

  function init(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    var found = Array.prototype.slice.call(searchRoot.querySelectorAll(ROOT_SELECTOR));
    if (searchRoot.matches && searchRoot.matches(ROOT_SELECTOR)) found.unshift(searchRoot);

    found.forEach(function (root) {
      bindProduct(root.getAttribute("data-product-id"));
      renderRoot(root);
    });
  }

  ["change", "input", "click"].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var form = event.target && event.target.closest
        ? event.target.closest(FORM_SELECTOR)
        : null;
      if (!form || form.matches("#sticky-atc-form") || form.closest(".prod__sticky-atc")) return;
      Array.prototype.slice.call(form.querySelectorAll(ROOT_SELECTOR)).forEach(scheduleRoot);
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  window.addEventListener("pageshow", function () { init(); });
  window.addEventListener("load", function () { init(); });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }

  window.DivetiaWelcome10Offer = {
    init: init,
    renderRoot: renderRoot
  };
})();
